// Logo ufficiale del brand (versioni ink/avorio con sfondo trasparente
// in /public/assets, rigenerabili con /app/scripts/brand_assets.py)
export const Logo = ({ light = false, small = false }) => (
  <img
    src={light ? "/assets/logo-ivory.png" : "/assets/logo-ink.png"}
    alt="Lacrime di Coccodrillo"
    data-testid="brand-logo"
    draggable={false}
    className={`select-none w-auto ${small ? "h-9" : "h-20"}`}
  />
);
